export default __webpack_public_path__ + "static/media/Laine_Lawson_Craft_AHV_In_Moms_We_Trust.0ced80ab.jpg";